import styled, { css } from "styled-components/macro";
import { mediaQueries } from "../styles/media.js";

// Shared by ReferralCallToAction, whose clickable box is a link rather than a div.
export const callToActionSurface = css`
  border-radius: 8px;
  background: linear-gradient(149deg, rgba(195, 255, 228, 1) 0%, rgba(118, 255, 197, 1) 100%);
`;

function CallToAction({ children }) {
  return <StyledCallToAction>{children}</StyledCallToAction>;
}

export default CallToAction;

const StyledCallToAction = styled.div`
  width: 100%;
  max-width: 60rem;

  padding: 0.5rem;

  justify-content: space-between;
  align-items: center;
  display: flex;
  flex-direction: column;

  ${mediaQueries.lg} {
    margin-left: auto;
    margin-right: auto;
  }

  ${callToActionSurface}

  h2 {
    color: var(--juno-color-text);
    font-size: 0.875rem;
    font-weight: var(--juno-font-weight-regular);
    line-height: 1.5;
    margin-bottom: 0.25rem;
  }

  p {
    font-size: 0.875rem;
    font-weight: var(--juno-font-weight-regular);
    line-height: 1.5;
    color: var(--juno-color-text-3);
    margin: 0 0 1rem 0;

    a,
    span {
      color: var(--juno-color-purple);
      font-weight: var(--juno-font-weight-bold);
    }
  }
`;
